var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"ai-btn",on:{"click":_vm.onAiButtonClick}},[_vm._v("AI助手")])])}
var staticRenderFns = []

export { render, staticRenderFns }